import styled from 'styled-components'
import { colors } from 'shared/lib'
import { SVGIcon } from 'shared/components/Icons'

const Circle = styled.div`
  border: 1px solid ${colors.FC2_BLACK};
  border-radius: 50%;
  height: 18px;
  width: 18px;
`

interface ICircleCheckStatus {
  isChecked: boolean
  onClick(): void
  qaAttr?: string
}

const CircleCheckStatus = ({ isChecked, onClick, qaAttr }: ICircleCheckStatus) => {
  return (
    <button type="button" data-qa={qaAttr} onClick={onClick}>
      {isChecked ? (
        <SVGIcon name="circleCheck" color={colors.FC2_BLACK} />
      ) : (
        <Circle data-testid="circle" />
      )}
    </button>
  )
}

export default CircleCheckStatus
